import React from "react";
import { cn } from "utils";
import Card from "components/Card";
import styles from "./reports.module.scss";
import TabList from "./TabList";
import { Outlet } from "react-router-dom";
import DownloadIcon from "assets/images/icon/download-icon";

const companyCards = [
  { title: "Download Employee Payroll Journal", icon: <DownloadIcon /> },
  { title: "Download Contractor Payroll Journal", icon: <DownloadIcon /> },
  { title: "Download W-2 Preview Report", icon: <DownloadIcon /> },
  { title: `Download W-2 Exempt Report`, icon: <DownloadIcon /> },
];

const Reports = () => {
  return (
    <div className={cn("content", styles.reportsContainer)}>
      <div style={{ padding: "16px 24px 16px 16px" }}>
        <div className="row mt-4">
          {companyCards?.map((item) => {
            return (
              <Card
                cardClassName="gap-5"
                title={item?.title}
                count={item?.count}
                icon={item?.icon}
                isImage={false}
              />
            );
          })}
        </div>
      </div>
      <div className={cn("mt-4 container-spacing", styles.container)}>
        <div className={cn("p-4", styles.tableContainer)}>
          <TabList />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Reports;
